var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',{staticClass:"fill-height"},[_c('router-view')],1),_c('QrCodeReader',{attrs:{"visibility":_vm.isDialogOpened},on:{"hideDialog":_vm.hideDialog}}),_c('snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }